import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import style from './payment.module.scss';
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import Button from "../Button/button";
import moment from "moment-jalaali"
import { CalculatePackagePrice, CreateTransaction, GetDiscountList } from "../../actions/APIcalls";
import { numberWithCommas } from "../../helpers/actions/splitNumberWithComma";
import Toast from "../Toast/Toast"
import DiscountCard from "./discountCard/discountCard"
import Modal from "../Modal/Modal";

const Payment = (props) => {
    const [calculatePrice, setCalculatePrice] = useState({ price: "0", difference: "0" })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const [discount, setDiscount] = useState({
        status: false,
        name: "",
        value: '',
        discountCode: '',
        error: '',
    })
    const [discountList, setDiscountList] = useState([])
    const [discountModalShow, setDiscountModalShow] = useState(false)

    //LifeCycles**********************************************
    useEffect(async () => {
        let params = {
            varietyCount: findParamValue('varietyCount'),
            channelCount: findParamValue('channelCount'),
            userCount: findParamValue('userCount'),
            pricingRange: findParamValue('pricingRange'),
            name: props.history.location.state.selectedPackage.name
        }
        let calcRes = await CalculatePackagePrice(params);
        console.log(calcRes);
        let temp = calculatePrice;
        temp.price = calcRes.data.price;
        temp.difference = calcRes.data.difference;
        temp.finalPrice = calcRes.data.finalPrice;
        setCalculatePrice({ ...temp })

    }, [])

    //apiCalls***********************************************
    const discountCodeCalc = async () => {
        let Discount = discount;
        if (discount.discountCode) {
            if (!discount.status) {
                let params = {
                    varietyCount: findParamValue('varietyCount'),
                    channelCount: findParamValue('channelCount'),
                    userCount: findParamValue('userCount'),
                    pricingRange: findParamValue('pricingRange'),
                    name: props.history.location.state.selectedPackage.name,
                    persianName: props.history.location.state.selectedPackage.persianName,
                    discountCode: discount.value
                }
                let calcRes = await CalculatePackagePrice(params);
                if (calcRes && calcRes.status === 200) {

                    Discount.value = calcRes.data.discount && calcRes.data.discount.name ? 'کد تخفیف  به مناسبت ' + (calcRes.data.discount.name) + ' با موفقیت اعمال شد. ' : 'کد تخفیف با موفقیت اعمال شد.'
                    Discount.status = true;
                    Discount.error = ''
                    Discount.price = calcRes.data.price;
                    Discount.finalPrice = calcRes.data.finalPrice;
                    Discount.discountAmount = calcRes.data.discount && calcRes.data.discount.amount && (calcRes.data.discount.amount)
                    Discount.discountName = calcRes.data.discount && calcRes.data.discount.name && (calcRes.data.discount.name)
                    setDiscount({ ...Discount })
                } else if (calcRes) {
                    Discount.error = calcRes.response.data.error;
                    setDiscount({ ...Discount })
                }
            } else {
                Discount.status = false;
                Discount.value = '';
                Discount.discountCode = '';
                Discount.error = '';
                delete Discount.finalPrice;
                delete Discount.discountAmount;
                delete Discount.discountName
                setDiscount({ ...Discount })

            }
        } else {
            Discount.error = 'لطفا کد تخفیف را وارد کنید.';
            setDiscount({ ...Discount })
        }
    }

    const getDiscountList = async () => {
        console.log(props, "props");
        let params = { accountId: props.user.account._id }
        console.log(params);
        let list = await GetDiscountList(params)
        console.log(list, 'listt');
        setDiscountList(list.data.discounts)
        setDiscountModalShow(true)
    }

    //renderers**********************************************  

    const transactionHandler = async () => {
        setLoading(true)
        let params = {
            varietyCount: findParamValue('varietyCount'),
            channelCount: findParamValue('channelCount'),
            userCount: findParamValue('userCount'),
            pricingRange: findParamValue('pricingRange'),
            name: props.history.location.state.selectedPackage.name,
            price: discount.status ? discount.finalPrice : calculatePrice.finalPrice
        }
        discount.status && (params.discountCode = discount.discountCode)
        let res = await CreateTransaction(params)
        if (res && res.data) {
            setLoading(false)
            window.location.href = 'https://mupra.ir/directIpg/' + res.data.token
        } else {
            setError(res.response.data.error)
        }
        console.log(res, "createTran");
    }
    const findParamValue = (tag) => {
        let index = props.history.location.state.selectedPackage.data.findIndex(item => item.tag === tag)
        if (index >= 0) {
            return props.history.location.state.selectedPackage.data[index].value
        }
    }
    const warningRenderer = () => {
        if (typeof props.history.location.state !== "undefined") {
            if (calculatePrice.difference > 0 && remainDays() > 0 && (checkDownGrade("varietyCount") || checkDownGrade("userCount") || checkDownGrade("channelCount"))) {
                return <div className={style.warning}>
                    <div className={style.colRight}>
                        <div className={style.icon}>h</div>
                    </div>
                    <div className={style.colLeft}>
                        <p>
                            برای فعال‌سازی
                            {typeof props.history.location.state !== "undefined" && " " + props.history.location.state.selectedPackage.persianName + " "}
                            باید حداکثر
                            {" " + returnValue('varietyCount') + " "}
                            تنوع،
                            {" " + returnValue('userCount') + " "}
                            کاربر و
                            {" " + returnValue('channelCount') + " "}
                            کانال داشته باشید.
                        </p>
                        <p>
                            در صورتی که هنگام اتمام
                            {typeof props.history.location.state !== "undefined" && " " + props.history.location.state.currentPackage.persianName + " "}
                            و فعال‌سازی
                            {typeof props.history.location.state !== "undefined" && " " + props.history.location.state.selectedPackage.persianName + " "}
                            (تاریخ {toPersianNumber(moment(props.history.location.state.currentPackage.endTime).format('jYYYY/jMM/jDD'))})،
                            تعداد موارد بالا بیشتر از حد مجاز باشد، ربات به‌صورت موقت غیرفعال می‌شود.
                        </p>
                    </div>
                </div>
            } else if (calculatePrice.difference > 0 && remainDays() <= 0 && ((checkDownGrade("varietyCount") || checkDownGrade("userCount") || checkDownGrade("channelCount")))) {
                return <div className={style.warning}>
                    <div className={style.colRight}>
                        <div className={style.icon}>h</div>
                    </div>
                    <div className={style.colLeft}>
                        <p>
                            برای فعال‌سازی
                            {typeof props.history.location.state !== "undefined" && " " + props.history.location.state.selectedPackage.persianName + " "}
                            باید حداکثر
                            {" " + returnValue('varietyCount') + " "}
                            تنوع،
                            {" " + returnValue('userCount') + " "}
                            کاربر و
                            {" " + returnValue('channelCount') + " "}
                            کانال داشته باشید.
                        </p>
                        <p>پس از خرید این بسته، ربات به‌صورت موقت غیرفعال می‌شود با رفع موارد خطا، ربات مجدد فعال
                            می‌شود.</p>

                    </div>
                </div>
            } else if (calculatePrice.difference < 0 && props.history.location.state.currentPackage.name !== "trialPackage") {
                return <div className={style.warning}>
                    <div className={style.colRight}>
                        <div className={style.icon}>h</div>
                    </div>
                    <div className={style.colLeft}>
                        <p>هم اکنون می‌توانید با دریافت وجه باقیمانده از
                            بسته {props.history.location.state.currentPackage.persianName}، با هزینه کمتری بسته خود را
                            ارتقا دهید.</p>
                    </div>
                </div>
            }

        }
    }
    //handlers***********************************************
    const discountHandler = (e) => {
        let Discount = { ...discount }
        Discount.value = e.target.value
        Discount.discountCode = e.target.value
        setDiscount({ ...Discount })
    }
    const listSelectedDiscountHandler = (code) => {
        let Discount = { ...discount }
        Discount.value = code
        Discount.discountCode = code
        setDiscount({ ...Discount })
        closeModalFunction()
    }
    const closeModalFunction = () => {
        setDiscountModalShow(false)
    }

    //funcions***********************************************
    const checkDownGrade = (property) => {
        if (typeof props.history.location.state !== "undefined") {
            let feature = props.history.location.state.selectedPackage.data.find(item => item.tag === property)
            console.log(props.history.location.state.currentPackage, feature.value);
            if (props.history.location.state.currentPackage[property] > feature.value) {
                return true
            } else return false
        }
    }
    const returnValue = (propsName) => {
        if (typeof props.history.location.state !== "undefined") {
            let feature = props.history.location.state.selectedPackage.data.find(item => item.tag === propsName)
            if (typeof feature !== "undefined") {
                return toPersianNumber(feature.value)
            }
        }
    }
    const remainDays = () => {
        const diffTime = (new Date(props.history.location.state.currentPackage.endTime) - new Date());
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    }
    return (
        <div className={style.wrapper}>
            <Toast
                tag='error'
                text={error}
                value={error}
                parentClose={() => setError('')}
            />
            <Modal
                tag='discountModalList'
                title='کد تخفیف'
                value={discountModalShow}
                parentClose={closeModalFunction}
            >
                {discountList.length > 0 ? discountList.map((item, index) => {
                    return <DiscountCard key={index} data={item} submitDiscount={listSelectedDiscountHandler} />
                })
                    :
                    <div className={style.emptyDiscountListWrapper}>
                        <div className={style.icon}></div>
                        <p>
                            .کاربر عزیز، درحال حاضر هیچ تخفیف فعالی برای شما موجود نیست
                        </p>
                    </div>
                }
            </Modal>

            <div className={style.header}>
                <h1>خرید و تمدید بسته</h1>
                <button className={style.backButton} onClick={() => props.history.push("/userpackages")}>
                    بازگشت و مشاهده بسته‌ها
                    <span className={style.icon}>c</span>
                </button>
            </div>

            {warningRenderer()}

            <div className={style.packageInfo}>
                <h2>{typeof props.history.location.state !== "undefined" && props.history.location.state.selectedPackage.persianName}
                    {remainDays() <= 0 ?
                        <span> {toPersianNumber(0)} روز باقیمانده از بسته قبلی </span>
                        :
                        <span> {toPersianNumber(Math.abs(remainDays()))}
                            {" "}روز باقیمانده از بسته فعلی تا تاریخ {" "}
                            {toPersianNumber(moment(props.history.location.state.currentPackage.endTime).format('jYYYY/jMM/jDD'))}</span>
                    }
                </h2>

                <div className={style.infoWrapper}>
                    {typeof props.history.location.state !== "undefined" &&
                        props.history.location.state.selectedPackage.data.map((item, index) => {
                            return <div className={style.innerBox}>
                                <div className={style.label}> {item.name}:</div>
                                {typeof item.value === "boolean" ? (item.value ? "دارد" : "ندارد") : toPersianNumber(item.value)}
                            </div>
                        })
                    }
                </div>
            </div>
            {console.log(props.history.location.state.currentPackage.currentPackagePrice, props.history.location.state.selectedPackage.basePrice)}
            {typeof props.history.location.state !== "undefined" && calculatePrice.difference > 0 && remainDays() > 0 &&
                <div className={style.calcPrice}>
                    <div className={style.label}>
                        :محاسبه قیمت
                    </div>
                    <div className={style.calc}>
                        <div className={style.purple}>
                            <div
                                className={style.boldText}>{toPersianNumber(numberWithCommas(props.history.location.state.selectedPackage.finalPrice))} تومان
                            </div>
                            هزینه {props.history.location.state.selectedPackage.persianName}
                        </div>
                        <div className={style.oprator}>-</div>
                        <div className={style.green}>
                            <div
                                className={style.boldText}>{toPersianNumber(numberWithCommas(calculatePrice.difference))} تومان
                            </div>
                            هزینه {typeof props.history.location.state.currentPackage.persianName !== 'undefined' && props.history.location.state.currentPackage.persianName}
                        </div>
                        <div className={style.oprator}>=</div>
                        <div className={style.blue}>
                            <div
                                className={style.boldText}>{toPersianNumber(numberWithCommas(props.history.location.state.selectedPackage.finalPrice - calculatePrice.difference))} تومان
                            </div>
                            قابل پرداخت
                        </div>
                    </div>

                </div>
            }

            {/* <div className={style.priceBox}>
                <div className={style.right}>
                    <div className={style.label}>
                        :هزینه نهایی
                    </div>
                    <div className={style.price}>
                        {typeof props.history.location.state !== "undefined" && (calculatePrice.difference > 0 ?
                            toPersianNumber(numberWithCommas(props.history.location.state.selectedPackage.price - calculatePrice.difference))
                            : toPersianNumber(numberWithCommas(props.history.location.state.selectedPackage.price)))}تومان
                    </div>
                </div>
                <div className={style.left}>
                    <div className={style.buttonWrapper}>
                        < Button
                            disabled={false}
                            tag={"cancel"}
                            type="outline"
                            label="بازگشت و مشاهده بسته‌ها"
                            onclick={() => props.history.push('/userpackages')} />
                    </div>

                    <div className={style.buttonWrapper}>
                        < Button
                            disabled={false}
                            tag="confirm"
                            type="solid"
                            label="تایید و پرداخت"
                            loading={loading}
                            onclick={transactionHandler} />
                    </div>
                </div>
            </div> */}

            <div className={style.priceBox}>
                <div className={style.discountRow}>
                    <div className={style.labelRow}>
                        <div className={style.label}>کد تخفیف</div>
                        <div className={style.discountsList} onClick={() => getDiscountList()}>مشاهده کد تخفیف‌های
                            موجود
                        </div>
                    </div>
                    <div className={style.inputWrapper}>
                        <input className={style[discount.status && 'greenInput']}
                            disabled={discount.status ? true : false} placeholder='کد تخفیف خود را وارد کنید'
                            value={toPersianNumber(discount.value)} onChange={(e) => discountHandler(e)} />
                        <div className={style.submitButton} onClick={() => discountCodeCalc()}>{discount.status ?
                            <div className={style.icon}>g</div> : 'اعمال'}</div>
                        <div className={style.error}>{discount.error}</div>
                    </div>
                    {discount.status && <div className={style.discountResults}>
                        <div className={style.label}>
                            :هزینه بسته
                            <div
                                className={style.lineThroughPrice}>{toPersianNumber(numberWithCommas(discount.price)) + ' تومان '}
                                <div className={style.line}></div>
                            </div>
                        </div>
                        <div className={style.label}>
                            :تخفیف
                            <div
                                className={style.discountValue}>{discount.discountAmount <= 100 ? toPersianNumber(discount.discountAmount) + '%' : toPersianNumber(numberWithCommas(discount.discountAmount)) + ' تومان '}</div>
                        </div>
                    </div>}
                </div>
                <div className={style.priceRow}>
                    <div className={style.right}>
                        <div className={style.label}>
                            :هزینه نهایی
                        </div>
                        <div className={style.price}>
                            {discount.status ? toPersianNumber(numberWithCommas(discount.finalPrice)) : toPersianNumber(numberWithCommas(calculatePrice.finalPrice))} تومان
                        </div>
                    </div>
                    <div className={style.left}>
                        <div className={style.buttonWrapper}>
                            < Button
                                disabled={false}
                                tag={"cancel"}
                                type="outline"
                                label="بازگشت و مشاهده بسته‌ها"
                                onclick={() => props.history.push('/userpackages')} />
                        </div>

                        <div className={style.buttonWrapper}>
                            < Button
                                disabled={false}
                                tag="confirm"
                                type="solid"
                                label="تایید و پرداخت"
                                loading={loading}
                                onclick={transactionHandler} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}
export default withRouter(Payment)
